import { createConfig, getConfiguration } from "../plugin/config.model";
import { ContactStoreNamespace } from "../../modules/contacts/store";
import { SelectedContactGroups } from "../../modules/contacts/store/types";

export const GroupConfigDict = createConfig({
  'groups': {
    action: `${ContactStoreNamespace}/${SelectedContactGroups.SET.ALL}`
  }
});

export const getGroupConfig = getConfiguration(GroupConfigDict);
